import React, { Component } from 'react';
import {Link} from 'react-router-dom';


class MorePro extends Component {
    constructor(){
        super();
        this.timer = null;
        this.indexRef = null;
        this.state = {
            data:[],
            thumb: 800
        }

    };


    componentDidMount(){
        this.getData();
        window.addEventListener('resize', this.resizeWin, false)
        this.resizeWin();
      
    }

    resizeWin = () => {
        
          if((window.innerWidth <= 900)){
            this.setState({thumb:1000})
    
          }
          else if((window.innerWidth > 800)){
            this.setState({thumb:800})
          }
   
        
        
      }

    getData = () => {
        fetch((`/api/more?id=${this.props.currID}`))
        .then(res => res.json())
        .then(data => this.setState({
            data: data.data}));

  
      }

      changeVid=(e)=>{
        var id = e.currentTarget.getAttribute('data-id')
        var slug = e.currentTarget.getAttribute('data-slug')
        this.props.changeVid(id,slug)
      }


   

    render() {
        const { data } = this.state;
        const {win} = this.props;
        const {initPro} = this.props;
        const { hover } = this.props;
        const { proActive } = this.props;
        const { image } = this.props;
        const { count } = this.props;
    return (
     
    
      <React.Fragment>
          
       
                

                
                {data.length?(
                    <React.Fragment >
                        {data.map((item,i)=>{
                            return(
                                <Link key={`moreProjects-${item.id}-${item.slug}`} to={`/work/${item.slug}`} className="singleMoreThumb col3 relative" onClick={this.changeVid} data-id={item.id} data-slug={item.slug}>
                                    <div className="ratH ratio169"></div>
                                    <div id={`proThumb-${i}`} onMouseOut={(this.props.deCrawl.bind(this))} onMouseOver={(this.props.initCrawl.bind(this))} data-item={item.media.length} data-id={i} data-info={`${item.title}${item.client?(` ————— ${item.client}`):('')}`} className={`fullWidth fullHeight moreThumb`} >
                                        {item.media.length?(
                                                                                  <img  key={(parseInt(hover)===i)?(`thumb-${i}+${image}`):(`thumb-${i}+${0}`)} className="imgCover moreProImg" src={((parseInt(hover)===i) && image && item.media[image])?(this.props.getImg(item.media[image].name, this.state.thumb)):(this.props.getImg(item.media[0].name,this.state.thumb))} alt={`Still from "${this.props.titleCase(item.title)}", ${item.client?("for "+(this.props.titleCase(item.client))):('')} Directed by David M. Helman`}></img>
                                        ):('')}
                                    </div>
                                 </Link>
                            )
                        })}
                           
                        </React.Fragment>
                ):('')}
                

    
       </React.Fragment>
    
    );
  }
}

export default MorePro;



// WEBPACK FOOTER //
// ./src/components/projects/morePro.js